<div class="footer-content">
  <div class="footer align-center">
    <div class="link-container">
      © 2024 - {{ currentYear }} Institut Wissen
    </div>
    <div
      class="link-container cursor-pointer hover-underline"
      [routerLink]="['about/contact']">
      Kontakt
    </div>
    <div class="icon-container flex-r gap-16">
      <div class="footer-icon-button cursor-pointer">
        <a [href]="socialMediaLinks.linkedin" target="_blank">
          <i class="fa-brands fa-linkedin"></i>
        </a>
      </div>
      <div class="footer-icon-button cursor-pointer">
        <a [href]="socialMediaLinks.facebook" target="_blank">
          <i class="fa-brands fa-square-facebook"></i>
        </a>
      </div>
      <div class="footer-icon-button cursor-pointer">
        <a [href]="socialMediaLinks.instagram" target="_blank">
          <i class="fa-brands fa-square-instagram"></i>
        </a>
      </div>
    </div>
    <div
      class="link-container cursor-pointer hover-underline"
      [routerLink]="['imprint']">
      Impressum
    </div>
    <div
      class="link-container cursor-pointer hover-underline"
      [routerLink]="['agb']">
      AGB
    </div>
    <div
      class="link-container cursor-pointer hover-underline"
      [routerLink]="['privacy-policy']">
      Datenschutz
    </div>
  </div>
</div>
